module.exports = __webpack_public_path__ + "img/personal-white.01f691ff.svg";